import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 建设单位信息维护
 */
export class BuildUnitInfoControllerSvr {
    constructor() {
        this.baseurl = 'BuildUnitInfoControllerSvr.assx/';
    }

    /**
     * 添加开发商
     * token:String, buildUnit:BuildUnit
     */
    AddBuildUnit(token, buildUnit){
        return request.post(this.baseurl + 'AddBuildUnit', Qs.stringify({ token:token, buildUnit:typeof buildUnit === 'undefined' || buildUnit === null ? '' : buildUnit.toString() }));
    }

    /**
     * 修改开发商
     * token:String, buildUnit:BuildUnit
     */
    ModifyBuildUnit(token, buildUnit){
        return request.post(this.baseurl + 'ModifyBuildUnit', Qs.stringify({ token:token, buildUnit:typeof buildUnit === 'undefined' || buildUnit === null ? '' : buildUnit.toString() }));
    }

    /**
     * 删除开发商
     * token:String, orgCode:String
     */
    DeteleBuildUnit(token, orgCode){
        return request.post(this.baseurl + 'DeteleBuildUnit', Qs.stringify({ token:token, orgCode:orgCode }));
    }

    /**
     * 获取开发商
     * token:String, orgCode:String
     */
    GetBuildUnit(token, orgCode){
        return request.post(this.baseurl + 'GetBuildUnit', Qs.stringify({ token:token, orgCode:orgCode }));
    }

    /**
     * 获取开发商列表
     * token:String, orgCode:String, orgName:String, startIndex:int, maxSize:int
     */
    GetBuildUnitList(token, orgCode, orgName, startIndex, maxSize){
        return request.post(this.baseurl + 'GetBuildUnitList', Qs.stringify({ token:token, orgCode:orgCode, orgName:orgName, startIndex:startIndex, maxSize:maxSize }));
    }
}